import useRNMsg, { ringleAppNavs } from './useRNMsg'

import { useCallback } from 'react'
import useAppRouter from '../../common/useAppRouter'
import useReturnFullUrl from './useReturnFullUrl'

// (2.0) 모바일 컴포넌트로 감싸져있는 웹뷰 페이지의 경우 새로운 모바일 스크린 스택으로 보내야한다.
const SHOULD_OPEN_NEW_SCREEN_URLS = ['/[lang]/webview/caf/overview/[lessonId]', '/[lang]/webview/caf/statistic']

const useWebviewNavigation = () => {
  const { sendPostMsg } = useRNMsg()
  const fullUrl = useReturnFullUrl()
  const router = useAppRouter()

  /**
   * sendPostMsg를 이용하여 Ringle App의 Screen으로 이동하는 로직 추상화
   */
  const navigate = useCallback(
    ({ url }) => {
      const isCurrentPageWrappedByMobileComponent = SHOULD_OPEN_NEW_SCREEN_URLS.some((url) => url === router.pathname)
      if (isCurrentPageWrappedByMobileComponent) {
        sendPostMsg({
          nav: ringleAppNavs.cafWebview,
          url: fullUrl(url),
        })
      } else {
        router.push(url)
      }
    },
    [fullUrl, sendPostMsg]
  )
  /**
   * Ringle App 의 opener Screen으로 이동
   * (Pop current WebView Screen)
   */
  const popBackToRingleApp = useCallback(
    (data?: any) => {
      console.log(data, 'data')
      sendPostMsg({
        type: 'ROUTER_BACK',
        startDate: data?.startDate || '',
        endDate: data?.endDate || '',
      })
    },
    [sendPostMsg]
  )

  return { navigate, popBackToRingleApp }
}
export default useWebviewNavigation
